import { cn } from "../utils";

type Props = {
  active: boolean;
};

export function StreamingIndicator({ active }: Props) {
  return (
    <div
      aria-label="Assistant is responding"
      role="status"
      className={cn(
        "inline-flex items-center gap-1 pt-4 pl-1 *:size-2.5 opacity-0 transition duration-1000",
        active && "opacity-50 scale-75 *:animation-duration-[.5s]",
      )}
    >
      <span className="typing-dot rounded-full bg-text-light" />
      <span className="typing-dot rounded-full bg-text-light" />
      <span className="typing-dot rounded-full bg-text-light" />
    </div>
  );
}
